import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_IDIOMAS } from 'store/modules/api/idiomas.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_IDIOMAS.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_IDIOMAS)

export default combineReducers({
  lista,
  isCarregandoLista,
})
